module.exports = __webpack_public_path__ + "src/images/bootstrap-logo.3274ded434cf673e730d4546ddb178fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bootstrap-logo.png
// module id = 97
// module chunks = 0